import { useProvideSnackBar } from './useSnackBar';
import { usePreconfiguredFetch } from './useProvidePreconfiguredFetch';
import { createContext, useContext, useEffect, useState } from 'react';
import { Partner } from '../@types/workplace';
import { Props } from '../@types';

type PartnerListContextType = {
    partnerList: Partner[];
};

const PartnerListContext = createContext<PartnerListContextType>({
    partnerList: [],
});

const useProvidePartnerList = () => {
    const { showError } = useProvideSnackBar();
    const { fetchResource } = usePreconfiguredFetch();
    const [partnerList, setPartnerList] = useState<Partner[]>([]);

    const fetchPartnerList = async () => {
        const resp = await fetchResource('/api/partners');

        if (resp.status === 200) {
            const partnerList: Partner[] = await resp.json();
            for (const partner of partnerList) {
                if (!partner.Name || partner.Name.trim().length === 0) {
                    showError('Hiányzó partner név');
                    return;
                }
                if (!partner.ID || partner.ID === 0) {
                    showError('Hiányzó partner azonosító');
                    return;
                }
            }

            setPartnerList(partnerList.sort((a: Partner, b: Partner) => a.Name.localeCompare(b.Name)));
            return;
        }

        if (resp.status === 401) {
            showError('A munkamenet lejárt, kérjük jelentkezzen be újra!');
            return;
        }

        showError('Hiba a partner lista lekérése közben!');
    };

    useEffect(() => {
        fetchPartnerList();
    }, []);

    return {
        partnerList,
    };
};

const usePartnerList = () => {
    return useContext(PartnerListContext);
};

const ProvidePartnerList = ({ children }: Props) => {
    const providePartnerList = useProvidePartnerList();
    return <PartnerListContext.Provider value={providePartnerList}>{children}</PartnerListContext.Provider>;
};

export { usePartnerList, ProvidePartnerList };
